import makeStyles from '@mui/styles/makeStyles';

const style = makeStyles(() => ({
  title: {
    padding: "12px 0",
  },
  inventoryQuotedTitle: {
    color: "#475467",
    fontFamily: "Manrope",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "20px",
    letterSpacing: "0.1px",
  },
}));

export default style;
